import React from 'react';

export const GlobalKnowledge = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      className='fill-primary-foreground '
    >
      <path d='M19 15.6812V5.04685L12.5 5.9406V16.9812L19 15.6812ZM11.5 16.9812V5.9406L5 5.04685V15.6812L11.5 16.9812ZM18.8625 4.05622C19.4656 3.97497 20 4.4406 20 5.04685V15.6812C20 16.1593 19.6625 16.5687 19.1969 16.6625L12.3938 18.0218C12.1344 18.075 11.8687 18.075 11.6094 18.0218L4.80312 16.6593C4.33437 16.5656 4 16.1562 4 15.6781V5.04685C4 4.4406 4.53438 3.97497 5.1375 4.05622L12 4.99997L18.8625 4.05622ZM2 6.04685C2 5.48747 2.45625 5.04685 3 5.04685V6.04685V8.99997V17.0812L11.8031 18.8406C11.9313 18.8656 12.0656 18.8656 12.1969 18.8406L21 17.0812V8.99997V6.04685V5.04685C21.5438 5.04685 22 5.48747 22 6.04685V17.0812C22 17.5593 21.6625 17.9687 21.1969 18.0625L12.3938 19.8218C12.1344 19.875 11.8687 19.875 11.6094 19.8218L2.80313 18.0593C2.3375 17.9687 2 17.5562 2 17.0812V6.04685Z' />
    </svg>
  )
}
